// This file is AUTOGENERATED, do not edit it manually!!!

import { users as usersde } from './usersResx.de';
import { users as usersen } from './usersResx.en';
import { users as usersen_risk } from './usersResx.en_risk';
import { users as userses } from './usersResx.es';
import { users as usersfr } from './usersResx.fr';
import { users as usersit } from './usersResx.it';
import { users as usersnl } from './usersResx.nl';
import { users as userspl } from './usersResx.pl';
import { users as userspt } from './usersResx.pt';
import { users as usersru } from './usersResx.ru';
import { users as userssk } from './usersResx.sk';
import { users as userssv } from './usersResx.sv';
import { users as userstr } from './usersResx.tr';

const langMap: { [k: string]: Partial<typeof usersen> } = {
    de: usersde,
    en: usersen,
    en_risk: usersen_risk,
    es: userses,
    fr: usersfr,
    it: usersit,
    nl: usersnl,
    pl: userspl,
    pt: userspt,
    ru: usersru,
    sk: userssk,
    sv: userssv,
    tr: userstr,
};

/* tslint:disable: max-line-length */
export const usersResx = {
    get active() {
        return langMap[ep.resxCulture].active || langMap.en.active;
    },
    get active_switch_description() {
        return langMap[ep.resxCulture].active_switch_description || langMap.en.active_switch_description;
    },
    get add_user() {
        return langMap[ep.resxCulture].add_user || langMap.en.add_user;
    },
    get apply() {
        return langMap[ep.resxCulture].apply || langMap.en.apply;
    },
    get assign() {
        return langMap[ep.resxCulture].assign || langMap.en.assign;
    },
    get assigned_activities_menu_title() {
        return langMap[ep.resxCulture].assigned_activities_menu_title || langMap.en.assigned_activities_menu_title;
    },
    get can_login() {
        return langMap[ep.resxCulture].can_login || langMap.en.can_login;
    },
    get can_login_switch_description() {
        return langMap[ep.resxCulture].can_login_switch_description || langMap.en.can_login_switch_description;
    },
    get cancel() {
        return langMap[ep.resxCulture].cancel || langMap.en.cancel;
    },
    get CanDenyLogin_User_DenyLoginYourself() {
        return langMap[ep.resxCulture].CanDenyLogin_User_DenyLoginYourself || langMap.en.CanDenyLogin_User_DenyLoginYourself;
    },
    get CanDenyLogin_User_LastAdministrator() {
        return langMap[ep.resxCulture].CanDenyLogin_User_LastAdministrator || langMap.en.CanDenyLogin_User_LastAdministrator;
    },
    get CanDisable_User_DisableYourself() {
        return langMap[ep.resxCulture].CanDisable_User_DisableYourself || langMap.en.CanDisable_User_DisableYourself;
    },
    get CanDisable_User_LastAdministrator() {
        return langMap[ep.resxCulture].CanDisable_User_LastAdministrator || langMap.en.CanDisable_User_LastAdministrator;
    },
    get cant_delete_user() {
        return langMap[ep.resxCulture].cant_delete_user || langMap.en.cant_delete_user;
    },
    get cant_login() {
        return langMap[ep.resxCulture].cant_login || langMap.en.cant_login;
    },
    get change_password() {
        return langMap[ep.resxCulture].change_password || langMap.en.change_password;
    },
    get close() {
        return langMap[ep.resxCulture].close || langMap.en.close;
    },
    get convert_title() {
        return langMap[ep.resxCulture].convert_title || langMap.en.convert_title;
    },
    get convert_to_regular() {
        return langMap[ep.resxCulture].convert_to_regular || langMap.en.convert_to_regular;
    },
    get convert_to_regular_title() {
        return langMap[ep.resxCulture].convert_to_regular_title || langMap.en.convert_to_regular_title;
    },
    get convert_to_regular_title_with_job_role() {
        return langMap[ep.resxCulture].convert_to_regular_title_with_job_role || langMap.en.convert_to_regular_title_with_job_role;
    },
    get deactivate() {
        return langMap[ep.resxCulture].deactivate || langMap.en.deactivate;
    },
    get deactivateTitle() {
        return langMap[ep.resxCulture].deactivateTitle || langMap.en.deactivateTitle;
    },
    get delete() {
        return langMap[ep.resxCulture].delete || langMap.en.delete;
    },
    get delete_confirm() {
        return langMap[ep.resxCulture].delete_confirm || langMap.en.delete_confirm;
    },
    get delete_skill_title() {
        return langMap[ep.resxCulture].delete_skill_title || langMap.en.delete_skill_title;
    },
    get delete_team_title() {
        return langMap[ep.resxCulture].delete_team_title || langMap.en.delete_team_title;
    },
    get DeleteRateBtnTitle() {
        return langMap[ep.resxCulture].DeleteRateBtnTitle || langMap.en.DeleteRateBtnTitle;
    },
    get Disable_Permission_Message() {
        return langMap[ep.resxCulture].Disable_Permission_Message || langMap.en.Disable_Permission_Message;
    },
    get Disable_Permission_Title() {
        return langMap[ep.resxCulture].Disable_Permission_Title || langMap.en.Disable_Permission_Title;
    },
    get DisplayName_customerId() {
        return langMap[ep.resxCulture].DisplayName_customerId || langMap.en.DisplayName_customerId;
    },
    get DisplayName_email() {
        return langMap[ep.resxCulture].DisplayName_email || langMap.en.DisplayName_email;
    },
    get DisplayName_hourlyRate() {
        return langMap[ep.resxCulture].DisplayName_hourlyRate || langMap.en.DisplayName_hourlyRate;
    },
    get DisplayName_hourlyRateInternal() {
        return langMap[ep.resxCulture].DisplayName_hourlyRateInternal || langMap.en.DisplayName_hourlyRateInternal;
    },
    get DisplayName_login() {
        return langMap[ep.resxCulture].DisplayName_login || langMap.en.DisplayName_login;
    },
    get email() {
        return langMap[ep.resxCulture].email || langMap.en.email;
    },
    get exclude() {
        return langMap[ep.resxCulture].exclude || langMap.en.exclude;
    },
    get filterbystatus_Active() {
        return langMap[ep.resxCulture].filterbystatus_Active || langMap.en.filterbystatus_Active;
    },
    get filterbystatus_All() {
        return langMap[ep.resxCulture].filterbystatus_All || langMap.en.filterbystatus_All;
    },
    get filterbystatus_CannotLogin() {
        return langMap[ep.resxCulture].filterbystatus_CannotLogin || langMap.en.filterbystatus_CannotLogin;
    },
    get filterbystatus_Inactive() {
        return langMap[ep.resxCulture].filterbystatus_Inactive || langMap.en.filterbystatus_Inactive;
    },
    get generate() {
        return langMap[ep.resxCulture].generate || langMap.en.generate;
    },
    get guest_portal_title() {
        return langMap[ep.resxCulture].guest_portal_title || langMap.en.guest_portal_title;
    },
    get guests_interaction() {
        return langMap[ep.resxCulture].guests_interaction || langMap.en.guests_interaction;
    },
    get guests_license() {
        return langMap[ep.resxCulture].guests_license || langMap.en.guests_license;
    },
    get guests_users_tab_title() {
        return langMap[ep.resxCulture].guests_users_tab_title || langMap.en.guests_users_tab_title;
    },
    get import_title() {
        return langMap[ep.resxCulture].import_title || langMap.en.import_title;
    },
    get inactive() {
        return langMap[ep.resxCulture].inactive || langMap.en.inactive;
    },
    get jobroles_updated_successfully() {
        return langMap[ep.resxCulture].jobroles_updated_successfully || langMap.en.jobroles_updated_successfully;
    },
    get lastActivityDate_title() {
        return langMap[ep.resxCulture].lastActivityDate_title || langMap.en.lastActivityDate_title;
    },
    get licensing_limits_warning() {
        return langMap[ep.resxCulture].licensing_limits_warning || langMap.en.licensing_limits_warning;
    },
    get name_column_title() {
        return langMap[ep.resxCulture].name_column_title || langMap.en.name_column_title;
    },
    get no_sercurity_logs() {
        return langMap[ep.resxCulture].no_sercurity_logs || langMap.en.no_sercurity_logs;
    },
    get password_changed() {
        return langMap[ep.resxCulture].password_changed || langMap.en.password_changed;
    },
    get personal_schedule_title() {
        return langMap[ep.resxCulture].personal_schedule_title || langMap.en.personal_schedule_title;
    },
    get regular_users_tab_title() {
        return langMap[ep.resxCulture].regular_users_tab_title || langMap.en.regular_users_tab_title;
    },
    get reload() {
        return langMap[ep.resxCulture].reload || langMap.en.reload;
    },
    get remove_confirm() {
        return langMap[ep.resxCulture].remove_confirm || langMap.en.remove_confirm;
    },
    get reset() {
        return langMap[ep.resxCulture].reset || langMap.en.reset;
    },
    get reset_password_confirmation() {
        return langMap[ep.resxCulture].reset_password_confirmation || langMap.en.reset_password_confirmation;
    },
    get reset_password_done() {
        return langMap[ep.resxCulture].reset_password_done || langMap.en.reset_password_done;
    },
    get reset_password_menu_title() {
        return langMap[ep.resxCulture].reset_password_menu_title || langMap.en.reset_password_menu_title;
    },
    get reset_password_title() {
        return langMap[ep.resxCulture].reset_password_title || langMap.en.reset_password_title;
    },
    get reset_permissions_confirmation() {
        return langMap[ep.resxCulture].reset_permissions_confirmation || langMap.en.reset_permissions_confirmation;
    },
    get reset_permissions_done() {
        return langMap[ep.resxCulture].reset_permissions_done || langMap.en.reset_permissions_done;
    },
    get reset_permissions_menu() {
        return langMap[ep.resxCulture].reset_permissions_menu || langMap.en.reset_permissions_menu;
    },
    get reset_permissions_title() {
        return langMap[ep.resxCulture].reset_permissions_title || langMap.en.reset_permissions_title;
    },
    get security_logs_action() {
        return langMap[ep.resxCulture].security_logs_action || langMap.en.security_logs_action;
    },
    get security_logs_date() {
        return langMap[ep.resxCulture].security_logs_date || langMap.en.security_logs_date;
    },
    get security_logs_modal_title() {
        return langMap[ep.resxCulture].security_logs_modal_title || langMap.en.security_logs_modal_title;
    },
    get security_logs_title() {
        return langMap[ep.resxCulture].security_logs_title || langMap.en.security_logs_title;
    },
    get securitylog_msg_GuestConverted() {
        return langMap[ep.resxCulture].securitylog_msg_GuestConverted || langMap.en.securitylog_msg_GuestConverted;
    },
    get securitylog_msg_LoginChanged() {
        return langMap[ep.resxCulture].securitylog_msg_LoginChanged || langMap.en.securitylog_msg_LoginChanged;
    },
    get securitylog_msg_LoginChangedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_LoginChangedBySelf || langMap.en.securitylog_msg_LoginChangedBySelf;
    },
    get securitylog_msg_PasswordChanged() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChanged || langMap.en.securitylog_msg_PasswordChanged;
    },
    get securitylog_msg_PasswordChangedByRecovery() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChangedByRecovery || langMap.en.securitylog_msg_PasswordChangedByRecovery;
    },
    get securitylog_msg_PasswordChangedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChangedBySelf || langMap.en.securitylog_msg_PasswordChangedBySelf;
    },
    get securitylog_msg_PasswordGenerated() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordGenerated || langMap.en.securitylog_msg_PasswordGenerated;
    },
    get securitylog_msg_PasswordGeneratedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordGeneratedBySelf || langMap.en.securitylog_msg_PasswordGeneratedBySelf;
    },
    get securitylog_msg_PasswordIncorrect() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordIncorrect || langMap.en.securitylog_msg_PasswordIncorrect;
    },
    get securitylog_msg_RecoveryRequest() {
        return langMap[ep.resxCulture].securitylog_msg_RecoveryRequest || langMap.en.securitylog_msg_RecoveryRequest;
    },
    get securitylog_msg_RoleChanged() {
        return langMap[ep.resxCulture].securitylog_msg_RoleChanged || langMap.en.securitylog_msg_RoleChanged;
    },
    get securitylog_msg_UserLockout() {
        return langMap[ep.resxCulture].securitylog_msg_UserLockout || langMap.en.securitylog_msg_UserLockout;
    },
    get securitylog_msg_UserLockoutDueToInactivity() {
        return langMap[ep.resxCulture].securitylog_msg_UserLockoutDueToInactivity || langMap.en.securitylog_msg_UserLockoutDueToInactivity;
    },
    get securitylog_msg_UserUnlocked() {
        return langMap[ep.resxCulture].securitylog_msg_UserUnlocked || langMap.en.securitylog_msg_UserUnlocked;
    },
    get selected_users() {
        return langMap[ep.resxCulture].selected_users || langMap.en.selected_users;
    },
    get Set_skills() {
        return langMap[ep.resxCulture].Set_skills || langMap.en.Set_skills;
    },
    get Set_teams() {
        return langMap[ep.resxCulture].Set_teams || langMap.en.Set_teams;
    },
    get show() {
        return langMap[ep.resxCulture].show || langMap.en.show;
    },
    get show_other_reasons() {
        return langMap[ep.resxCulture].show_other_reasons || langMap.en.show_other_reasons;
    },
    get skills() {
        return langMap[ep.resxCulture].skills || langMap.en.skills;
    },
    get skills_updated_successfully() {
        return langMap[ep.resxCulture].skills_updated_successfully || langMap.en.skills_updated_successfully;
    },
    get skillsDeleteConfirm() {
        return langMap[ep.resxCulture].skillsDeleteConfirm || langMap.en.skillsDeleteConfirm;
    },
    get spaces() {
        return langMap[ep.resxCulture].spaces || langMap.en.spaces;
    },
    get suggest_deactivate() {
        return langMap[ep.resxCulture].suggest_deactivate || langMap.en.suggest_deactivate;
    },
    get teams() {
        return langMap[ep.resxCulture].teams || langMap.en.teams;
    },
    get teams_updated_successfully() {
        return langMap[ep.resxCulture].teams_updated_successfully || langMap.en.teams_updated_successfully;
    },
    get teamsDeleteConfirm() {
        return langMap[ep.resxCulture].teamsDeleteConfirm || langMap.en.teamsDeleteConfirm;
    },
    get TimerText() {
        return langMap[ep.resxCulture].TimerText || langMap.en.TimerText;
    },
    get unlock() {
        return langMap[ep.resxCulture].unlock || langMap.en.unlock;
    },
    get user_conversion_done() {
        return langMap[ep.resxCulture].user_conversion_done || langMap.en.user_conversion_done;
    },
    get user_conversion_title() {
        return langMap[ep.resxCulture].user_conversion_title || langMap.en.user_conversion_title;
    },
    get user_duplicate_email_error() {
        return langMap[ep.resxCulture].user_duplicate_email_error || langMap.en.user_duplicate_email_error;
    },
    get user_duplicate_login_error() {
        return langMap[ep.resxCulture].user_duplicate_login_error || langMap.en.user_duplicate_login_error;
    },
    get user_licensing_limits_warning() {
        return langMap[ep.resxCulture].user_licensing_limits_warning || langMap.en.user_licensing_limits_warning;
    },
    get User_NotFound_Title() {
        return langMap[ep.resxCulture].User_NotFound_Title || langMap.en.User_NotFound_Title;
    },
    get userRates() {
        return langMap[ep.resxCulture].userRates || langMap.en.userRates;
    },
    get userRates_changed_by() {
        return langMap[ep.resxCulture].userRates_changed_by || langMap.en.userRates_changed_by;
    },
    get userRates_date() {
        return langMap[ep.resxCulture].userRates_date || langMap.en.userRates_date;
    },
    get userRates_hourlyRate() {
        return langMap[ep.resxCulture].userRates_hourlyRate || langMap.en.userRates_hourlyRate;
    },
    get userRates_hourlyRateInternal() {
        return langMap[ep.resxCulture].userRates_hourlyRateInternal || langMap.en.userRates_hourlyRateInternal;
    },
    get userRates_title() {
        return langMap[ep.resxCulture].userRates_title || langMap.en.userRates_title;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.users = usersResx;
